<template>
  <b-modal centered
          id="how-to-use-popup"
          ref="how-to-use-popup-en"
          v-bind:visible="showHowToUsePopupEn"
          size="lg"
          title="How it works"
          hide-header-close
          footer-class="bordered-footer"
          ok-title="Close"
          ok-variant="secondary"
          body-class="scroll-modal"
          ok-only>
    <p class="how-to-use-text">The Abbreviations expansion tool detects and expands abbreviations found in rabbinic and modern texts.
    </p>
    <h2 class="how-to-use-header">How to use:</h2>
    <p class="how-to-use-text">
      <ul style="list-style-type: disc">
        <li>Enter text in the main Text area and click on the "Apply Abbreviations" button</li>
        <li>The expanded abbreviations will appear in the results section.</li>
        <li>Use the right and left arrow keys or the mouse to navigate between the expanded abbreviations 
        </li>
        <li>Abbreviations with multiple expansion options will appear on the right side of the screen.
            Use the mouse or the Up and Down arrow keys to navigate the options.
        </li>
      </ul>
    </p>
    <h2 class="how-to-use-header">Toolbar</h2>
    <ul class="tools">
      <li>
        Copy: Keyboard shortcut Shift+c
        <ul>
          <li>Copy without original abbreviations:<br/>
            Click on the arrow button that appears on the side of the copy button
            and select the relevant checkbox. 
            <br/>
            If the resulting expansion is identical to the abbreviation, for example <span class="f-narkis">רש"י</span>,
             the original abbreviation wont be copied.
          </li>
        </ul>
      </li>
      <li>Download: Keyboard shortcut Shift+d 
        <ul>
          <li>Option to download with or without original abbreviations.</li>
        </ul>
      </li>
      <li>Incrase / Decrease font size
        <ul>
          <li>Incrase font size: Keyboard shortcut Shift++</li>
          <li>Decrease font size: Keyboard shortcut Shift+-</li>
        </ul>
      </li>
      <li>Redo / Undo action
        <ul>
          <li>Redo action: Keyboard shortcut Shift+y</li>
          <li>Undo action: Keyboard shortcut Shift+z</li>
        </ul>
      </li>
      <li>Show / Hide original abbreviations: Keyboard shortcut Shift+t
        <ul>
          <li>original abbreviations will appear on the side of the text in gray.</li>
        </ul>
      </li>
      <li>Ctrl+e Edit text: Keyboard shortcut 
        <ul>
          <li>To edit multiple words,
            Select the words to edit with the mouse and click on "Edit text" or on Ctrl+e.
            <br/>The text that appears in the text area is the original text before expansion.
          </li>
        </ul>
      </li>
      <li>Enter new text: When entering a new text is selected, the existing text will be deleted.</li>
      <li>
        Saved changes: Every five minutes the browser auto-saves the text and a notification appears on the screen.
      </li>
    </ul>
    <h2 class="how-to-use-header">Personal area</h2>
    <p class="how-to-use-text mt-3">
      <strong>Personal list</strong>
    </p>
    <p class="how-to-use-text">
      The personal list is a collection of abbreviation expansions created by the user. 
      These expansions always appear at the top of the results list.
      <br/>To use the personal list you must be logged in to your account.
    </p>
    <ul class="dictionary-tree">
      <li>To add an expansion to your personal list: In the results area, click on the star that appears when hovering
         on an expansion. The expansion will be added to the top of the personal list.
      </li>
      <li>To remove an expansion from the personal list:
        <ul>
          <li>Hover over the selcted word and click on the X.</li>
          <li>In the results section, clicking on the star while hovering on the selcted word removes 
            the words from the personal list.
            <ul>
              <li>It is not possible to permanently exclude expansions from Dicta's list. Expansions from Dicta's list that have 
                been removed will remain on the list.
              </li>
            </ul>
          </li>
        </ul>
      </li>
      <li>You can scroll down the word list according to Hebrew letters by clicking on the letters that appear at 
        the top of the Personal list screen.
      </li>
    </ul>
    <p class="how-to-use-text">
      <strong>Excluding expansions</strong>
    </p>
    <p class="how-to-use-text">You can mark expansions in the results section as invalid and they will be excluded from 
      appearing as expansion results in the the future.
    </p>
    <ul class="dictionary-tree">
      <li>In order to mark an expansion invalid, you must be logged in to your personal account.
      </li>
      <li>
        To exclude an expansion hover over the selected expansion in the result list and click on the Down arrow.
        The word will be added to the list of words for exclusion and be colored light gray.<br/>
        To re-include the word, click again on the arrow.
      </li>
      <li>Exclude / Include word: Keyboard shortcut Shift+x
      </li>
      <li>To remove an expansion from the Excluded expansions list, 
        hover over the expansion and click on the Remove expansion link.
      </li>
      <li>If all expansions have been marked invalid the tool will not expand abbreviations.
      </li>
    </ul>
    <p class="how-to-use-text">The Abbreviation expander is a free tool developed by Dicta.
    </p>
  </b-modal>
</template>

<script>
export default {
  name: 'HowToUsePopupEn',
  props: ['showHowToUsePopupEn'],
  watch: {
    showHowToUsePopupEn (newShowHowToUsePopupEn) {
      if (newShowHowToUsePopupEn) this.$refs['how-to-use-popup-en'].show()
    }
  }
}
</script>
<style scoped>
#how-to-use-popup p, #how-to-use-popup li {
  text-align: justify;
}
li {
  margin: 10px 0;
}
.tools li li {
  list-style-type: circle;
}
.dictionary-tree li {
  list-style-type: disc;
}
.dictionary-tree li li li {
  list-style-type: circle;
}
</style>
